import { AtsWorkplaceTypesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const workplaceTypeLabel = (workplaceType: AtsWorkplaceTypesEnum) => {
  const workplaceTypes: Record<AtsWorkplaceTypesEnum, string> = {
    onsite: i18n.t('ats.workplace_types.onsite'),
    hybrid: i18n.t('ats.workplace_types.hybrid'),
    remote: i18n.t('ats.workplace_types.remote'),
  }

  return workplaceTypes[workplaceType]
}
